import {reportServices} from "../../service/reportService";
import {campaignConstants} from "../constants/campaignsConstants";
import {campaignServices} from "../../service/campaignService";
import {alertActions} from "./alertActions";
import ExportCSV from "../../components/export/ExportCSV";
import {integrationService} from "../../service/integrationService";
import {groupBy1Constants} from "../constants/groupBy1Constants";
import {trafficSourceServices} from "../../service/trafficSourceService";

export const campaignActions = {
    getReport,
    archive,
    restore,
    loadMoreRows,
    updateName,
    updateTags,
    updateFilterTrafficSources,
    updateOrderBy,
    updateSortBy,
    updateSortColumns,
    rerender,
    setSelectedRows,
    changeTrackingDomain,
    changeWorkspace,
    updateDetailsReportingView
};

function loadMoreRows(groupBy, from, to, timezone, name, tags, filterTrafficSources, isDeleted, page, pageSize, orderBy, sortBy, currencyCode, metricFilters, columns, workspace) {
    return dispatch => {
        dispatch({type: campaignConstants.CAMPAIGNS_LOADING_SPINNER});
        dispatch(alertActions.error(""));
        reportServices.getReport(
            {
                groupBy,
                from,
                to,
                timezone,
                name,
                tags,
                filterTrafficSources,
                isDeleted,
                page,
                pageSize,
                orderBy,
                sortBy,
                currencyCode,
                metricFilters,
                columns,
                workspace
            }
        ).then((result) => {
            dispatch({type: campaignConstants.CAMPAIGNS_INFINITY_SCROLL, result});
        }).catch((error) => {
            dispatch({type: campaignConstants.CAMPAIGNS_ERROR, error});
            dispatch(alertActions.error(error?.response?.data?.error));
        });
    };
}

function getReport(groupBy, from, to, timezone, name, tags, filterTrafficSources, isDeleted, page, pageSize, orderBy, sortBy, currencyCode, exportData, metricFilters, columns, workspace) {
    return dispatch => {
        dispatch({type: campaignConstants.CAMPAIGNS_LOADING_SPINNER});
        dispatch(alertActions.error(""));
        reportServices.getReport(
            {
                groupBy,
                from,
                to,
                timezone,
                name,
                tags,
                filterTrafficSources,
                isDeleted,
                page,
                pageSize,
                orderBy,
                sortBy,
                currencyCode,
                exportData,
                metricFilters,
                columns,
                workspace
            }
        ).then((result) => {
            if (exportData === "csv") {
                ExportCSV({fileName: "campaigns_" + from + "_to_" + to, data: result});
                dispatch({type: campaignConstants.CAMPAIGNS_STOP_LOADING_SPINNER});
            } else {
                dispatch({type: campaignConstants.CAMPAIGNS_GET_DATA, result});
            }
        }).catch((error) => {
            dispatch({type: campaignConstants.CAMPAIGNS_ERROR, error});
            dispatch(alertActions.error(error?.response?.data?.error));
        });
    };
}

function archive(ids) {
    return dispatch => {
        dispatch({type: campaignConstants.CAMPAIGNS_LOADING_SPINNER});
        campaignServices.archive(ids)
            .then(() => {
                dispatch({type: campaignConstants.CAMPAIGNS_ARCHIVE});
            }).catch((error) => {
                dispatch({type: campaignConstants.CAMPAIGNS_ERROR, error});
            }
        );
    };
}

function restore(ids) {
    return dispatch => {
        dispatch({type: campaignConstants.CAMPAIGNS_LOADING_SPINNER});
        campaignServices.restore(ids)
            .then(() => {
                dispatch({type: campaignConstants.CAMPAIGNS_RESTORE});
            }).catch((error) => {
                dispatch({type: campaignConstants.CAMPAIGNS_ERROR, error});
            }
        );
    };
}

function updateOrderBy(orderBy) {
    return (dispatch) => {
        dispatch({type: campaignConstants.CAMPAIGNS_UPDATE_ORDER_BY, orderBy});
    };
}

function updateSortBy(sortBy) {
    return (dispatch) => {
        dispatch({type: campaignConstants.CAMPAIGNS_UPDATE_SORT_BY, sortBy});
    };
}

function updateName(name) {
    return (dispatch) => {
        dispatch({type: campaignConstants.CAMPAIGNS_UPDATE_NAME, name});
        dispatch({type: campaignConstants.CAMPAIGNS_SET_SELECTED_ROW, selectedRows: new Set()}); // reset selected rows.
    };
}

function updateTags(tags) {
    return (dispatch) => {
        dispatch({type: campaignConstants.CAMPAIGNS_UPDATE_TAGS, tags});
        dispatch({type: campaignConstants.CAMPAIGNS_SET_SELECTED_ROW, selectedRows: new Set()}); // reset selected rows.
    };
}

function updateFilterTrafficSources(filterTrafficSources) {
    return async (dispatch, getState) => {
        const sources = (filterTrafficSources || []).slice(0, 1);
        dispatch({type: campaignConstants.CAMPAIGNS_UPDATE_FILTER_TRAFFIC_SOURCES, filterTrafficSources: sources});
        dispatch({type: campaignConstants.CAMPAIGNS_SET_SELECTED_ROW, selectedRows: new Set()}); // reset selected rows.
        dispatch({type: groupBy1Constants.GROUP_BY_1_SET_INTEGRATION_DATA, integration: null});
        dispatch({type: groupBy1Constants.GROUP_BY_1_SET_TRAFFIC_SOURCE_DATA, trafficSource: null});

        // Ignore requests from a source that has since been replaced or cleared.
        const isCurrent = () => getState().campaign.filterTrafficSources === sources;
        if (sources[0]?.value > 0) {
            try {
                const trafficSource = await trafficSourceServices.find(sources[0].value);
                if (!isCurrent()) return;
                dispatch({type: groupBy1Constants.GROUP_BY_1_SET_TRAFFIC_SOURCE_DATA, trafficSource});
                if (trafficSource?.integrationId > 0) {
                    const integration = await integrationService.findIntegration(trafficSource.integrationId);
                    if (isCurrent()) dispatch({type: groupBy1Constants.GROUP_BY_1_SET_INTEGRATION_DATA, integration});
                }
            } catch (e) {
                if (!isCurrent()) return;
                dispatch({type: groupBy1Constants.GROUP_BY_1_ERROR, e});
                dispatch(alertActions.error(e?.response?.data?.error));
            }
        }
    };
}

function updateSortColumns(sortColumns) {
    return (dispatch) => {
        dispatch({type: campaignConstants.CAMPAIGNS_UPDATE_SORT_COLUMNS, sortColumns});
    };
}

function rerender() {
    return dispatch => {
        dispatch({type: campaignConstants.CAMPAIGNS_RERENDER});
    };
}

function setSelectedRows(selectedRows) {
    return dispatch => {
        dispatch({type: campaignConstants.CAMPAIGNS_SET_SELECTED_ROW, selectedRows});
    };
}

function changeTrackingDomain(data) {
    return dispatch => {
        dispatch({type: campaignConstants.CAMPAIGNS_LOADING_SPINNER});
        campaignServices.bulkCampaignUpdate(data)
            .then(() => {
                dispatch({type: campaignConstants.BULK_UPDATE_CHANGE_TRACKING_DOMAIN});
                dispatch(alertActions.success("Tracking domain is successfully updated."));
            }).catch((error) => {
                dispatch(alertActions.error("Changing tracking domain failed: " + error?.response?.data?.error));
            }
        );
    };
}

function changeWorkspace(data) {
    return dispatch => {
        dispatch({type: campaignConstants.CAMPAIGNS_LOADING_SPINNER});
        campaignServices.bulkCampaignUpdate(data)
            .then(() => {
                dispatch({type: campaignConstants.BULK_UPDATE_CHANGE_WORKSPACE});
                dispatch(alertActions.success("Workspace is successfully updated."));
            }).catch((error) => {
                dispatch(alertActions.error("Changing workspace failed: " + error?.response?.data?.error));
            }
        );
    };
}

function updateDetailsReportingView(detailsReportingView) {
    return (dispatch) => {
        if (detailsReportingView !== 'tabs' && detailsReportingView !== 'tree') {
            return;
        }
        try {
            localStorage.setItem(campaignConstants.DETAILS_REPORTING_VIEW_STORAGE_KEY, detailsReportingView);
        } catch {
            // Keep switching views even if browser storage is unavailable.
        }
        dispatch({type: campaignConstants.CAMPAIGNS_UPDATE_DETAILS_REPORTING_VIEW, detailsReportingView});
        dispatch({type: campaignConstants.CAMPAIGNS_SET_SELECTED_ROW, selectedRows: new Set()}); // reset selected rows.
    };
}
